var $05e247fd2960981e$exports = {};
$05e247fd2960981e$exports = {
  "alpha": "Alfa",
  "black": "fekete",
  "blue": "K\xE9k",
  "blue purple": "k\xE9k lila",
  "brightness": "F\xE9nyess\xE9g",
  "brown": "barna",
  "brown yellow": "barna s\xE1rga",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "ci\xE1nk\xE9k",
  "cyan blue": "ci\xE1nk\xE9k",
  "dark": "s\xF6t\xE9t",
  "gray": "sz\xFCrke",
  "grayish": "sz\xFCrk\xE9s",
  "green": "Z\xF6ld",
  "green cyan": "z\xF6ld ci\xE1nk\xE9k",
  "hue": "Sz\xEDn\xE1rnyalat",
  "light": "vil\xE1gos",
  "lightness": "Vil\xE1goss\xE1g",
  "magenta": "b\xEDbor",
  "magenta pink": "b\xEDbor r\xF3zsasz\xEDn",
  "orange": "narancs",
  "orange yellow": "narancss\xE1rga",
  "pale": "halv\xE1ny",
  "pink": "r\xF3zsasz\xEDn",
  "pink red": "r\xF3zsasz\xEDn piros",
  "purple": "lila",
  "purple magenta": "lila b\xEDbor",
  "red": "Piros",
  "red orange": "piros narancs",
  "saturation": "Tel\xEDtetts\xE9g",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " \xE1tl\xE1tsz\xF3");
  },
  "very dark": "nagyon s\xF6t\xE9t",
  "very light": "nagyon vil\xE1gos",
  "vibrant": "\xE9l\xE9nk",
  "white": "feh\xE9r",
  "yellow": "s\xE1rga",
  "yellow green": "s\xE1rga z\xF6ld"
};
export { $05e247fd2960981e$exports as default };